module.exports = __webpack_public_path__ + "img/1.94d3d458.png";